import { useRouter } from 'next/router'
import Image from 'next/image'
import clsx from 'clsx'

import InteractiveDiv from '../../InteractiveDiv'
import getHeaderLogoPath from '../../../../app/utils/getHeaderLogoPath'
import isAppWhiteLabeled from '../../../../app/utils/isAppWhiteLabeled'
import getWhiteLabelClassName from '../../../../app/utils/getWhiteLabelClassName'
import { WhiteLabeledAppName } from '../../../../app/types'

import styles from './MainNavbarBrand.module.scss'

const DefaultBrandImageHeight = 40
const DefaultBrandImageWidth = 176

function MainNavbarBrand() {
  const router = useRouter()

  const isWhiteLabeled = isAppWhiteLabeled()

  function handleNavigateToHome() {
    router.push('/')
  }

  const headerLogoPath = getHeaderLogoPath()

  return (
    <InteractiveDiv
      className={clsx(
        styles.navBrand,
        {
          [styles.whiteLabeled]: isWhiteLabeled,
        },
        getWhiteLabelClassName({
          [WhiteLabeledAppName.Corner]: styles.cornerApp,
          [WhiteLabeledAppName.HeatRestauranger]: styles.heatApp,
          [WhiteLabeledAppName.Olandschoklad]: styles.olandschokladApp,
          [WhiteLabeledAppName.MorenoPizza]: styles.morenoPizzaApp,
          [WhiteLabeledAppName.BruketIWiared]: styles.bruketIWiaredApp,
          [WhiteLabeledAppName.LundsKommun]: styles.lundsKommunApp,
          [WhiteLabeledAppName.NordrestAxis]: styles.nordrestAxisApp,
          [WhiteLabeledAppName.KlappenBageriet]: styles.klappenBagerietApp,
          [WhiteLabeledAppName.KlappenHalster]: styles.klappenHalsterApp,
          [WhiteLabeledAppName.KlappenToppstugan]: styles.klappenToppstuganApp,
          [WhiteLabeledAppName.TacosAndTequila]: styles.tacosAndTequilaApp,
          [WhiteLabeledAppName.ButchersMarket]: styles.butchersMarketApp,
          [WhiteLabeledAppName.KafeMagasinet]: styles.kafeMagasinetApp,
          [WhiteLabeledAppName.Brutale]: styles.brutaleApp,
          [WhiteLabeledAppName.Strandgatan]: styles.strandgatanApp,
        }),
      )}
      onClick={handleNavigateToHome}
    >
      <Image
        width={DefaultBrandImageWidth}
        height={DefaultBrandImageHeight}
        alt="logo"
        src={headerLogoPath}
        priority
      />
    </InteractiveDiv>
  )
}

export default MainNavbarBrand
